import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ChangePassword from './pages/ChangePassword';
import Verify from './pages/Verify';

// ====== 权限路由配置 ======
// 当前默认使用B权限，后期做用户权限功能后再打开A权限路由

// --- A权限页面 (暂时注释) ---
// import Home from './pages/Home';
// import Help from './pages/Help';
// import MyApps from './pages/MyApps';

// --- B权限页面 ---
import HomeB from './pages/HomeB';
import RentalProtection from './pages/RentalProtection/RentalProtection';
import StartupConfig from './pages/StartupConfig';
import Help from './pages/Help';

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/change-password" element={<ChangePassword />} />
      <Route path="/verify" element={<Verify />} />

      {/* ====== A权限路由 (暂时注释，后期根据权限判断加载) ====== */}
      {/* <Route path="/" element={<Home />} /> */}
      {/* <Route path="/my-apps" element={<MyApps />} /> */}
      {/* <Route path="/help" element={<Help />} /> */}

      {/* ====== B权限路由 ====== */}
      <Route path="/" element={<HomeB />} />
      <Route path="/config" element={<RentalProtection />} />
      <Route path="/startup" element={<StartupConfig />} />
      <Route path="/help" element={<Help />} />

      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}

export default App;
